import { initialState } from '@/Helpers.js';
import BasePolicy from '@/policies/BasePolicy.js';

export default class UserPolicy extends BasePolicy {
    before(user) {
        if (user.is_super_admin) {
            return true;
        }
    }

    viewAny(user) {
        if (user.is_admin) {
            return true;
        }

        const permission = 'view all users';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    view(user, person) {
        if (user.is_admin) {
            return true;
        }

        if (user.id === person.id) {
            return true;
        }

        const permission = 'view a user';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(person);
        }

        return user.hasPermissionTo(permission);
    }

    viewEmail(user, person) {
        if (user.is_admin) {
            return true;
        }

        if (user.id === person.id) {
            return true;
        }

        const permission = "view a user's email";

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    create(user) {
        if (user.is_admin) {
            return true;
        }

        const permission = 'create a user';

        if (user.hasGroupPermissionTo(permission)) {
            return false;
        }

        return user.hasPermissionTo(permission);
    }

    update(user, person) {
        if (user.is_admin) {
            return true;
        }

        const permission = 'edit a user';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(person);
        }

        return user.hasPermissionTo(permission);
    }

    updateName(user, person) {
        if (user.is_admin) {
            return true;
        }

        if (user.id === person.id) {
            return initialState('InstitutionSettings.allow_users_to_edit_own_name', true);
        }

        return false;
    }

    delete(user) {
        const permission = 'delete a user';

        if (user.hasGroupPermissionTo(permission)) {
            return false;
        }

        return user.hasPermissionTo(permission);
    }
}
